<template>
  <div v-if="show" class="conflict-modal-overlay" @click="closeModal">
    <div class="conflict-modal" @click.stop>
      <div class="conflict-header">
        <h4>{{ config.conflictModal.title }}</h4>
      </div>
      <div class="conflict-body">
        <p>{{ conflictMessage }}</p>
        <p><strong>{{ config.conflictModal.question }}</strong></p>
      </div>
      <div class="conflict-actions">
        <button class="btn-conflict btn-cancel" @click="closeModal">{{ config.conflictModal.cancel }}</button>
        <button class="btn-conflict btn-replace" @click="replaceConflictingSchedule">{{ config.conflictModal.replace }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConflictModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    conflictMessage: {
      type: String,
      default: ''
    },
    conflictData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      config: {
        conflictModal: {
          title: "Conflicto de horarios",
          question: "¿Qué deseas hacer con el horario conflictivo?",
          cancel: "Cancelar",
          replace: "Reemplazar"
        }
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    
    replaceConflictingSchedule() {
      this.$emit('replace-conflict', this.conflictData)
      this.closeModal()
    }
  }
}
</script>

<style scoped>
.conflict-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.conflict-modal {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  width: 90%;
  max-width: 450px;
  max-height: 80%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.conflict-header {
  padding: 20px;
  border-bottom: 1px solid #eee;
  text-align: center;
}

.conflict-header h4 {
  margin: 0;
  color: #333;
}

.conflict-body {
  padding: 20px;
  border-bottom: 1px solid #eee;
  color: #555;
  font-size: 0.95rem;
  line-height: 1.6;
}

.conflict-actions {
  padding: 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: space-around;
  gap: 10px;
}

.btn-conflict {
  flex: 1;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  transition: background-color 0.2s ease;
}

.btn-conflict:hover {
  transform: translateY(-2px);
}

.btn-conflict:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  color: #666;
}

.btn-conflict.btn-cancel {
  background-color: #f0f2f5;
  color: #333;
}

.btn-conflict.btn-cancel:hover:not(:disabled) {
  background-color: #e0e2e6;
}

.btn-conflict.btn-replace {
  background-color: #dc3545;
  color: white;
}

.btn-conflict.btn-replace:hover:not(:disabled) {
  background-color: #c82333;
}
</style> 